import { observer } from 'mobx-react-lite';

import { Hero } from '@cfm-media/pwa-ui-components';
import { parseHtml } from '../core/utils';
import { useStore } from '../core/store';
import { useTranslation } from '../core/utils/translations';

import { ContentWrapper } from '../components/content-wrapper';
import { PageWrapper } from '../components/page-wrapper';

const configMap = {
  de: { key: 3827553, domain: 'de', lang: 'de' },
  ch: { key: 2104479, domain: 'ch', lang: 'de' },
  nl: { key: 3827559, domain: 'nl', lang: 'nl' },
  xx: { key: 3827553, domain: 'de', lang: 'de' }, // fallback de
};

export const RentalCar = observer(() => {
  const { t } = useTranslation('rental-car-page');

  const { BookingStore } = useStore();
  const agency = BookingStore?.booking?.data?.agency;

  return (
    <>
      <PageWrapper>
        <Hero
          image="public/assets/images/teasers/rental-car.jpg"
          iconClass="icon-car"
          headline="Mietwagen"
          overlay
        />

        <ContentWrapper>{parseHtml(t('body-text'))}</ContentWrapper>

        <ScWidgetDisplay nationality={agency?.nationality} />
      </PageWrapper>
    </>
  );
});

function ScWidgetDisplay({ nationality }) {
  const config = configMap[nationality] || configMap['xx'];

  return (
    <div className="max-w-5xl mx-auto">
      <iframe
        id="scRentalContentFrame"
        className="block h-[100vh] w-full overflow-hidden border-none"
        type="text/html"
        src={`https://widget.sunnycars.app?affiliatekey=${config.key}&domain=${config.domain}&lang=${config.lang}`}
      ></iframe>
    </div>
  );
}
